<template>
  <div>
    <div class="container-fluid">
      <div class="page-title">
        <div class="row">
          <div v-if="title != 'Settlements'" class="col-xxl-9 col-md-8 col-5 d-flex ms-xxl-5">
            <h2>{{ title }}</h2>
          </div>
          <div v-else class="col-xxl-8 ms-xxl-5">
            <h2>{{ title }}</h2>
          </div>
          <div v-if="title === 'Settlements'" class="col-xxl-3 col-md-4 col-7 d-flex justify-content-end">
            <p class="payment-method">Payment method:<strong class="cash">{{ driverInfo.payment_method }}</strong></p>
          </div>
          <div v-if="title === 'Overview'" class="col-xxl-2 col-md-1 col-1">
            <button class="refresh-button" @click="refreshOverview" :disabled="loading">
              <template v-if="!loading">
                <span>Refresh</span>
                <i class="fa fa-refresh ms-1"></i>
              </template>
              <template v-else>
                <span>Loading...</span>
              </template>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Loading Overlay -->
    <div v-if="loading" class="spinner-overlay">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useOverviewStore } from '@/store/driver/overview';
import { defineProps } from 'vue';
import { useDriverStore } from '@/store/driver/driver';

const driverStore = useDriverStore();
const { fetchDriverInfo } = driverStore;

const props = defineProps({
  title: {
    type: String,
    default: 'home'
  },
  main: {
    type: String,
    default: ''
  }
});

const driverInfo = computed(() => driverStore.driverInfo);

onMounted(() => {
  fetchDriverInfo();
});

const overviewStore = useOverviewStore();
const { fetchOverviewInfo, setActiveButton } = overviewStore;

const loading = ref(false);

const refreshOverview = () => {
  loading.value = true;
  // 模擬 1 秒的 loading 動作
  setTimeout(() => {
    setActiveButton('This month');
    fetchOverviewInfo('this_month');
    loading.value = false;
  }, 1000);
};
</script>

<style scoped>
.page-title {
  font-family: Euclid Square;
  font-size: 36px;
  font-weight: 600;
  line-height: 45.65px;
  text-align: left;
  background-color: #e6e9ec !important;
  padding-top: 30px !important;
}

.refresh-button {
  width: 160px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #0d2b3e;
  border: 2px solid #00c962;
  border-radius: 30px;
  background-color: transparent;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-left: 100px;
}

.refresh-button:hover {
  background-color: #e6f7e7;
}

.refresh-button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.payment-method {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.cash {
  font-size: 18px;
  border: 2px solid #00c962;
  padding: 2px 10px;
  border-radius: 10%;
  margin-left: 5px;
}

/* Loading overlay 與 spinner 樣式 */
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #00c962;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@media (max-width: 992px) {
  .page-title {
    background-color: #e6e9ec !important;
    padding-top: 70px !important;
  }
}

@media (max-width: 1700px) {
  .refresh-button {
    margin-left: 20px;
  }
}

@media (max-width: 768px) {
  .refresh-button {
    margin-left: 60px;
  }
}
</style>
